"use strict";

require("core-js/features/array/find");
require("core-js/es/math/trunc");
require("core-js/features/array/for-each");